/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createStore, applyMiddleware, compose, Store } from 'redux';
import type { ReduxDevtoolsExtensionCompose } from '@redux-devtools/extension';
import { router5Middleware } from 'redux-router5';
import reducer from './reducers/index';
import { RootState } from 'data/store.typings';
import { Router } from 'router5';
import LcStorageMiddleware from './middlewares/LcStorageMiddleware';
import { createEpicMiddleware } from 'redux-observable';
import { createSSEMiddleware } from './middlewares/SSEMiddelware';

export const epicMiddleware = createEpicMiddleware<any, any, RootState>();
export const SSEMiddleware = createSSEMiddleware();

const composeWithDevTools: ReduxDevtoolsExtensionCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;

const configureStore = (router: Router, initialState: Partial<RootState> = {}): Store<RootState> => {
    const middleWares = [SSEMiddleware, router5Middleware(router), LcStorageMiddleware, epicMiddleware];

    const enhancers = [applyMiddleware(...middleWares)];

    return createStore(reducer, initialState, composeWithDevTools(...enhancers));
};

export default configureStore;
